import { gql } from '@apollo/client';

export const VACCINATION_CARD_ENTRY_FIELDS = gql`
  fragment VaccinationCardEntryFields on VaccinationCardEntry {
    id
    vaccination_card_id
    product_id
    vaccine_name
    applied_date
    next_application_date
    lot_number
    weight_grams_snapshot
    veterinarian_id
    veterinarian_name_snapshot
    veterinarian_license_snapshot
    source
    sale_order_id
    notes
    voided_at
    void_reason
    created_at
  }
`;

export const VACCINATION_CARD_QUERY = gql`
  ${VACCINATION_CARD_ENTRY_FIELDS}
  query VaccinationCard($pet_id: ID!) {
    vaccinationCard(pet_id: $pet_id) {
      id
      pet_id
      card_number
      created_at
      entries {
        ...VaccinationCardEntryFields
      }
    }
  }
`;

export const ADD_MANUAL_VACCINATION_ENTRY_MUTATION = gql`
  ${VACCINATION_CARD_ENTRY_FIELDS}
  mutation AddManualVaccinationEntry($input: AddManualVaccinationEntryInputGql!) {
    addManualVaccinationEntry(input: $input) {
      ...VaccinationCardEntryFields
    }
  }
`;

export const VOID_VACCINATION_CARD_ENTRY_MUTATION = gql`
  ${VACCINATION_CARD_ENTRY_FIELDS}
  mutation VoidVaccinationCardEntry($input: VoidVaccinationCardEntryInputGql!) {
    voidVaccinationCardEntry(input: $input) {
      ...VaccinationCardEntryFields
    }
  }
`;
